export default "__VITE_ASSET__e4e544c7__"